import barba from '@barba/core';
import barbaCss from '@barba/css';
import barbaPrefetch from '@barba/prefetch';
import jump from 'jump.js'

class MelBarba extends HTMLElement {
  constructor(self) {
    self = super(self);
    return self;
  }

  static get is() {
    return 'mel-barba';
  }

  connectedCallback() {
    if (!window.barbaInitialised) {
      const that = this;
      barba.use(barbaCss);
      barba.use(barbaPrefetch);
      barba.init({
        preventRunning: true,
        views: [
          {
            namespace: 'index',
            beforeLeave(data) {
              that._hideProjectsMenu();
              that._setCurrentMenuItem(data.next.url.path);
            },
            afterEnter(data) {
              that._afterEnter(data);
            }
          },
        ]
      });
      window.barbaInitialised = true;
    }
  }

  _setCurrentMenuItem(path) {
    const mainMenu = document.querySelector('.c-nav-primary');
    
    if (mainMenu) {
      const currentMenuItem = mainMenu.querySelector('.current-menu-item');
      const nextLink = mainMenu.querySelector(`a[href$="${path}"]`);

      if (currentMenuItem) {
        currentMenuItem.classList.remove('current-menu-item');
        currentMenuItem.querySelector('a').setAttribute('aria-current', false);
      }

      if (nextLink) {
        nextLink.classList.add('current-menu-item');
        nextLink.setAttribute('aria-current', true);
      }
    }
  }

  _hideProjectsMenu() {
    const projectsMenu = document.querySelector('mel-nav');

    if (projectsMenu) {
      projectsMenu.removeAttribute('opened');
    }
  }

  _afterEnter(data) {
    document.dispatchEvent(new Event('initialised'));
    window.scrollTo(0, 0);

    // Get hash value
    const hash = window.location.hash;
    const target = hash ? document.querySelector(hash) : null;

    if (target) {
      jump(target, {
        duration: 500,
        offset: 0,
        callback: undefined,
        a11y: true
      });
    }

    if ('grunticon' in window) {
      grunticon.svgLoadedCallback();
    }

    // Contact Form 7
    if ('jQuery' in window) {
      if (!jQuery('div.wpcf7 > form').length) return;

      jQuery('div.wpcf7 > form').each(function() {
        var $form = jQuery(this);
        wpcf7.initForm($form);

        if (wpcf7.cached) {
          wpcf7.refill($form);
        }

        // recaptchaCallback();
      });
    }

    this._updateBodyClasses(data);
  }

  _updateBodyClasses(data) {
    if (data.next.html) {
      const parser = new DOMParser().parseFromString(data.next.html, 'text/html');
      const body = document.querySelector('body');

      if (parser.querySelector('body')) {
        body.className = parser.querySelector('body').classList.value;
      }
    }
  }
}

customElements.define(MelBarba.is, MelBarba);